var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChangeModal',{ref:"modal",attrs:{"help":"HelpTeam"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Team Description & Visibility")])])
}
var staticRenderFns = []

export { render, staticRenderFns }